import * as React from "react";
import { mapRenderer, StringRenderer, ReadOnlySwitchRenderer } from "../shared/renderers/table";
import { IntlShape } from "react-intl";
import { TableColumns } from "../shared/crud/list";
import { messages } from "./messages";
import type { DisplayEntity } from "./types";

function renderTickerFilter({ value }: { value?: string }): React.ReactElement | null {
  const list = (value || "")
    .split(",")
    .map(s => s.trim())
    .filter(Boolean);

  if (list.length === 0) {
    return <span>-</span>;
  }

  const full = list.join(", ");
  const MAX = 3;
  const preview = list.slice(0, MAX).join(", ");
  const display = list.length > MAX ? `${preview} …` : full;

  return (
    <span className="d-inline-block text-truncate" style={{ maxWidth: "100%" }} title={full}>
      {display}
    </span>
  );
}

export default function getTableColumns(intl: IntlShape): TableColumns<DisplayEntity> {
  return {
    active: {
      width: 80,
      renderer: ReadOnlySwitchRenderer,
    },

    ticker: {
      width: 220,
      renderer: mapRenderer(StringRenderer, (v?: string) => v ?? ""),
    },

    label: {
      width: 220,
      renderer: mapRenderer(StringRenderer, (v?: string) => v ?? ""),
    },

    visible: {
      width: 220,
      renderer: mapRenderer(StringRenderer, (v?: string) => v ?? ""),
    },

    entityFilter: {
      width: 220,
      renderer: mapRenderer(StringRenderer, (v?: "PROPERTY" | "ACCOMMODATION") => {
        if (v === "PROPERTY") return intl.formatMessage(messages.locationProperty);
        if (v === "ACCOMMODATION") return intl.formatMessage(messages.locationAccommodation);
        return "";
      }),
    },

    tickerFilter: {
      width: 260,
      renderer: renderTickerFilter as React.FC<{ value?: string }>,
    },

    contentType: {
      width: 220,
      renderer: mapRenderer(StringRenderer, (v?: "HTML" | "VIDEO" | "IMAGE") => {
        if (!v) return "";
        if (v === "HTML") return intl.formatMessage(messages.html);
        if (v === "VIDEO") return intl.formatMessage(messages.video);
        if (v === "IMAGE") return intl.formatMessage(messages.image);
        return v;
      }),
    },

    position: {
      width: 180,
      align: "left",
      renderer: mapRenderer(StringRenderer, (v?: number) => (v != null ? String(v) : "")),
    },
  };
}
